// extracted by mini-css-extract-plugin
module.exports = {"root":"PageRoot-styles-module--root--1tfLb","main":"PageRoot-styles-module--main--Xvto2"};